import { render, staticRenderFns } from "./ForecastListSwitcher.vue?vue&type=template&id=235cb38b&"
import script from "./ForecastListSwitcher.vue?vue&type=script&lang=js&"
export * from "./ForecastListSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ForecastListSwitcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports